import { WidgetState } from './types.ts';

/**
 * Basic email format check: *@*.*
 * @param email - Email string to validate
 * @returns Whether the email matches a minimal valid pattern
 */
export const isValidEmail = (email: string): boolean => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

export const isBookingReady = (reservation: WidgetState) => {
  return (
    !!reservation.date && !!reservation.availability && !!reservation.option
  );
};

export const isInfoReady = (reservation: WidgetState) => {
  return (
    isBookingReady(reservation) &&
    !!reservation.first_name &&
    !!reservation.last_name &&
    !!reservation.phone_country &&
    !!reservation.phone_number &&
    !!reservation.email &&
    isValidEmail(reservation.email)
  );
};

export const isEventInfoReady = (reservation: WidgetState) => {
  return (
    !!reservation.first_name &&
    !!reservation.last_name &&
    !!reservation.phone_number &&
    !!reservation.email &&
    isValidEmail(reservation.email)
  );
};

export const isPaymentReady = (reservation: WidgetState) => {
  return !!reservation.payment_method || !!reservation.ach_payment_id;
};
